import React from 'react';


/**
 * Message组件
 */
export default class Messages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'isLoggedIn': false,
      'brand': {
        'text': '郑州立行信息技术有限公司',
        'url': '/'
      },
      'nav': [
        {
          'text': '首页',
          'url': ''
        },
        {
          'text': 'ERP业务系统',
          'url': ''
        },
      ]
    }
  }

  componentDidMount() {
    //this.loadDataFromServer();
  }

  render() {
    return;
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/Messages.js